export var EventType;
(function (EventType) {
    EventType[EventType["NOTE_OFF"] = 0] = "NOTE_OFF";
    EventType[EventType["NOTE_ON"] = 1] = "NOTE_ON";
    EventType[EventType["POLYPHONIC_KEY_PRESSURE"] = 2] = "POLYPHONIC_KEY_PRESSURE";
    EventType[EventType["CONTROL_CHANGE"] = 3] = "CONTROL_CHANGE";
    EventType[EventType["PROGRAM_CHANGE"] = 4] = "PROGRAM_CHANGE";
    EventType[EventType["CHANNEL_PRESSURE"] = 5] = "CHANNEL_PRESSURE";
    EventType[EventType["PITCH_WHEEL"] = 6] = "PITCH_WHEEL";
    EventType[EventType["UNKNOWN"] = 7] = "UNKNOWN";
})(EventType || (EventType = {}));
function EventTypeEnumValueToKey(id) {
    return (Object.fromEntries(Object.entries(EventType).map(([a, b]) => ([b, a])))[id] || "UNKNOWN");
}
function parseEvtBytes(e) {
    var _a;
    let [status, ...data] = e.data;
    let cmdRaw = status >> 4;
    let cmd = (_a = {
        0b1000: EventType.NOTE_OFF,
        0b1001: EventType.NOTE_ON,
        0b1011: EventType.CONTROL_CHANGE,
        0b1010: EventType.POLYPHONIC_KEY_PRESSURE,
        0b1100: EventType.PROGRAM_CHANGE,
        0b1101: EventType.CHANNEL_PRESSURE,
        0b1110: EventType.PITCH_WHEEL
    }[cmdRaw]) !== null && _a !== void 0 ? _a : EventType.UNKNOWN;
    var channel = e.data[0] & 0xf;
    return {
        timestamp: new Date(),
        channel,
        cmdName: EventTypeEnumValueToKey(cmd),
        cmd,
        data: data,
        cmdRaw,
        raw: e.data
    };
}
export function connectToWebMIDI(cb) {
    console.log('Connecting to controllers.');
    navigator.requestMIDIAccess().then((midiAccess) => {
        var inputs = midiAccess.inputs.values();
        for (var iterItem = inputs.next(); iterItem && !iterItem.done; iterItem = inputs.next()) {
            const input = iterItem.value;
            console.log(input, input.name, input.manufacturer, input.version);
            input.addEventListener('midimessage', (evt) => {
                let eventData = parseEvtBytes(evt);
                cb === null || cb === void 0 ? void 0 : cb(eventData);
            });
        }
    }, (error) => {
        console.log("No MIDI access: " + error.code);
    });
}
